export default {
  'portal.error.automy.title': 'No pudimos completar el regreso automático a AUTOMY.',
  'portal.error.auth.title': 'No pudimos completar el cambio al portal automáticamente.',
  'portal.error.description': `Por favor, vuelve a iniciar sesión para continuar. Esto nos ayuda a mantener tu información segura y garantizar que todo funcione correctamente.`,
};
